module.exports = __webpack_public_path__ + "static/media/certilite.4707e488.png";